const FILE_VISIBILITY = Object.freeze({
    PUBLIC: 'public',
    PRIVATE: 'private',
    PROTECTED: 'protected',
});

const FILE_SECURITY_CLASS = Object.freeze({
    PUBLIC_ASSET: 'public_asset',
    RESTRICTED: 'restricted',
    INTERNAL: 'internal',
});

const FILE_LINKED_ENTITY_TYPE = Object.freeze({
    DOCTOR: 'doctor',
    USER: 'user',
    ORGANIZATION: 'organization',
    PATIENT: 'patient',
    OTHER: 'other',
});

const BUCKET_TYPE = Object.freeze({
    PUBLIC:  'public',
    PRIVATE: 'private',
    DEFAULT: 'default',
});

const FILE_UPLOAD_PURPOSE = Object.freeze({
    DOCTOR_PROFILE_PICTURE: 'doctor_profile_picture',
    DOCTOR_NID:             'doctor_nid',
    DOCTOR_SIGNATURE:       'doctor_signature',
});

const UPLOAD_PURPOSE_CONFIG = Object.freeze({
    [FILE_UPLOAD_PURPOSE.DOCTOR_PROFILE_PICTURE]: {
        folder:     'doctor/profile-picture',
        bucketType: BUCKET_TYPE.PUBLIC,
    },
    [FILE_UPLOAD_PURPOSE.DOCTOR_NID]: {
        folder:     'doctor/identity/nid',
        bucketType: BUCKET_TYPE.PRIVATE,
    },
    [FILE_UPLOAD_PURPOSE.DOCTOR_SIGNATURE]: {
        folder:     'doctor/identity/signature',
        bucketType: BUCKET_TYPE.PRIVATE,
    },
});

module.exports = {
    FILE_VISIBILITY,
    FILE_SECURITY_CLASS,
    FILE_LINKED_ENTITY_TYPE,
    BUCKET_TYPE,
    FILE_UPLOAD_PURPOSE,
    UPLOAD_PURPOSE_CONFIG,
};
  